import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=16074e9e&scoped=true&"
import script from "./OrderCreate.vue?vue&type=script&lang=js&"
export * from "./OrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=16074e9e&prod&lang=scss&"
import style1 from "./OrderCreate.vue?vue&type=style&index=1&id=16074e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16074e9e",
  null
  
)

export default component.exports